module.exports = __webpack_public_path__ + "img/14.d79b0af0.png";